import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatLabel } from '@angular/material/form-field';
import { CommonFunctionsService } from '../../../services/common-functions.service';
import { CostReviewGeneralConditions } from '../../../models/CostReviewGeneralConditions';
import { Constants } from '../../../constants/constants';
import { ReviewDetails } from '../../../models/ReviewDetails';
import { Subject, takeUntil } from 'rxjs';
import { ReviewService } from '../../../services/review.service';
import { CommonDataService } from '../../../services/common-data.service';
import { ExportTitleCaseMap } from '../../../models/PdfRelatedModels';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExportObjectAsFieldValuePDFOptions } from '../../../models/ExportObjectAsFieldValuePDFOptions';
import { SiRadioButtonComponent } from "../../Si-Web-Toolkit/si-radio-button/si-radio-button.component";
import { SiCheckBoxComponent } from '../../Si-Web-Toolkit/si-check-box/si-check-box.component';
import { FormControl, FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { SiFormFieldComponent } from '../../Si-Web-Toolkit/si-form-field/si-form-field.component';
import { CostReviewSecurityEnUsGeneralConditions } from '../../../models/CostReviewSecurityEnUsGeneralConditions';
import { CostReviewSecurityEnUsAttributes } from '../../../models/CostReviewSecurityEnUsAttributes';
import { OptionalWorkflowDirective } from '../../../Directives/optional-workflow-directive';
import { ReviewDetailTabsService } from '../../../lib/review-detail-tabs.service';
import { DecimalPrecisionPipe } from '../../../pipes/decimal-precision/decimal-precision.pipe';
import { CostReviewDatabaseRecord } from '../../../models/CostReviewDatabaseRecord';
import { TrackChangesDirective } from '../../../Directives/track-changes.directive';
import { CostReviewEstimateType } from '../../../public-api';
import { SiCheckBoxGroupComponent } from '../../Si-Web-Toolkit/si-check-box-group/si-check-box-group.component';
import { MultilingualCurrencyPipe } from '../../../pipes/multilingual-currency/multilingual-currency.pipe';

@Component({
  selector: 'app-sol-conditions-tab',
  imports: [
    MatLabel,
    CommonModule,
    MatIconModule,
    TranslatePipe,
    SiRadioButtonComponent,
    ReactiveFormsModule,
    MatRadioModule,
    FormsModule,
    SiFormFieldComponent,
    OptionalWorkflowDirective,
    MatTooltipModule,
    MatIconModule,
    TrackChangesDirective,
    SiCheckBoxGroupComponent,
    MultilingualCurrencyPipe,
    SiCheckBoxComponent
],
  providers: [DecimalPrecisionPipe, MultilingualCurrencyPipe],
  templateUrl: './sol-conditions-tab.component.html',
  styleUrl: './sol-conditions-tab.component.scss'
})
export class SolConditionsTabComponent implements OnInit, OnDestroy {

  allPersonnelOptions: { id: number}[] = [
    { id: 1 },
    { id: 3 },
    { id: 2 },
    { id: 4 }
  ];

  destroy$ = new Subject<void>();
  constants = Constants;
  costReviewGeneralConditions: CostReviewGeneralConditions | undefined;
  costReviewSecurityEnUsGeneralConditions: CostReviewSecurityEnUsGeneralConditions | undefined;
  business: string = '';
  isSalePriceGreaterThan150: boolean = false;
  @Input() showSectionNotApplicableMsg: boolean = true;
  @Output() disablePdf = new EventEmitter<boolean>();
  isReadOnlyMode: boolean = false;
  checkSellPriceForCPM: boolean = false;
  optionalWorkflowCondition: boolean = false;
  isDisabled: boolean = false;
  temporarySitePersonnelList: string[] = ['LABORER', 'SECURITY_GUARD', 'SAFETY_OFFICER', 'SUPERINTENDENT'];
 costReviewSOLConditionFormGroup!: FormGroup<{
    minority: FormControl<string>;
    prevailingWage: FormControl<string>;
    tradeAgreementAct: FormControl<string>;
    buyAmerica: FormControl<string>;
    buyAmericanAct: FormControl<string>;
    bimModeling: FormControl<string>;
    schedulerEstimate: FormControl<string>;
    cpmHoursEstimated: FormControl<string>;
    hardwareSoftwareCapacity: FormControl<string>;
    serviceContract: FormControl<string>;
    specialProgramming: FormControl<string>;
    specialCommissioningProceduresRequired: FormControl<string>;
    testProcessReviewed: FormControl<string>;
    taggingLabeling: FormControl<string>;
    installationStandards: FormControl<string>;
    localCodeRestrictions: FormControl<string>;
    trailerRentalSpace: FormControl<string>;
    utilitiesCosts: FormControl<string>;
    projectIsPhased: FormControl<string>;
    escortsRequired: FormControl<string>;
    customerTaxExempt: FormControl<string>;
    officeSuppliesCosts: FormControl<string>;
    liftCosts: FormControl<string>;
    bim360FieldConfiguration: FormControl<string>;
    taxRequired: FormControl<string>;
    salesTax: FormControl<string>;
    equipmentEnclosures: FormControl<string>;
    deviceAccessPanels: FormControl<string>;
    fieldProcurementManager: FormControl<string>;
    serviceContractGeneralConditions: FormControl<string>;
    unionLabor: FormControl<string>;
    prevailingWages: FormControl<string>;
    certifiedPayrollReports: FormControl<string>;
    temporarySitePersonnel: FormControl<string[]>;
    sparepartpercent: FormControl<number>;
    ifYesDescribe: FormControl<string>;
    ifyesdesc: FormControl<string>;
    sparepointcapacity: FormControl<number>;
    ifYesInstallationStandards: FormControl<string>;
  }>;



  constructor(private readonly commonDataService: CommonDataService,
    private readonly commonFunctionsService: CommonFunctionsService,
    private readonly decimalPrecisionPipe: DecimalPrecisionPipe,
    private readonly reviewService: ReviewService,
    private readonly translate: TranslateService,
    private readonly formBuilder: NonNullableFormBuilder,
    private readonly reviewDetailTabsService: ReviewDetailTabsService) { }

  ngOnInit(): void {
    this.getReviewLibraryState();
    this.business = this.reviewService.getBusiness();
    const estimateType = this.reviewService.convertToEstimateType(
      this.reviewDetailTabsService.getOptionalWorkflowAndEstimateType().optionalEstimateType
    );
    this.isSalePriceGreaterThan150 = estimateType === CostReviewEstimateType.EstimateGreater150K;
    this.initializeConditionFormGroup();
    this.initializeConditionsData();
    if(this.business && (this.business === this.constants.BUSINESS_SECURITY || this.business === this.constants.BUSINESS_FIRE)){
      this.optionalWorkflowCondition = this.reviewDetailTabsService.getOptionalWorkflowAndEstimateType()?.optionalWorkflow || false;
    }
    this.commonDataService.triggerTabMethod$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.exportToPdf(this.reviewService.selectedReview, Constants.SOL_CONDITIONS);
      });
    this.sendDisablePdfEvent();
    this.setupReadOnlyMode();
    this.updateFormEditability();
    this.subscribeToReviewFormDataSyncRequest();
  }

  get isConditionsChecked(): boolean {
    if (this.business === this.constants.BUSINESS_SECURITY) {
      return !!this.costReviewSecurityEnUsGeneralConditions?.isGeneralConditionChecked;
    }
    return !!this.costReviewGeneralConditions?.isGeneralConditionsApplicable;
  }

  get isSectionVisible(): boolean {
    return !!this.costReviewGeneralConditions && (this.showConditionData() || this.optionalWorkflowCondition);
  }

  get isSectionLocked(): boolean {
    return this.optionalWorkflowCondition && !this.isConditionsChecked;
  }

  onConditionsToggle(checked: boolean): void {
    if (this.costReviewGeneralConditions) {
      this.costReviewGeneralConditions.isGeneralConditionsApplicable = checked;
    }
    if (this.costReviewSecurityEnUsGeneralConditions) {
      this.costReviewSecurityEnUsGeneralConditions.isGeneralConditionChecked = checked;
    }
    this.updateFormEditability();
  }

  private updateFormEditability(): void {
    if (!this.costReviewSOLConditionFormGroup) return;
    const lockedByReadOnly = !this.reviewDetailTabsService.getIsLibraryUsedInSQ() && this.isReadOnlyMode;
    if (lockedByReadOnly || this.isSectionLocked) {
      this.costReviewSOLConditionFormGroup.disable();
    } else {
      this.costReviewSOLConditionFormGroup.enable();
    }
  }

  /** Allows the host app to force this tab to push its latest data without waiting for tab switch/destroy. */
  private subscribeToReviewFormDataSyncRequest(): void {
    this.reviewDetailTabsService.getReviewFormDataSyncRequested$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.pushFormDataToService());
  }

  private getReviewLibraryState(): void {
    this.isDisabled = this.reviewDetailTabsService.getReviewLibraryDisableFlag();
  }

  private setupReadOnlyMode(): void {
    this.commonDataService.libraryReadOnlyMode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((readOnly: boolean) => {
        const isLibraryUsedInSQ = this.reviewDetailTabsService.getIsLibraryUsedInSQ();
        if (isLibraryUsedInSQ) {
          this.isDisabled = readOnly;
          this.isReadOnlyMode = false;
        } else {
          this.isReadOnlyMode = readOnly;
        }
        this.syncIfYesDescribeEnabledState();
        this.updateFormEditability();
      });
    this.subscribeToDataRefresh();
    this.subscribeToProjectIsPhasedChanges();
  }

  // The control's own disabled state (set via enable()/disable()) drives si-form-field's CVA-based
  // disabled flag, independent of the template's [isDisabled] input - must be re-synced on every change.
  private syncIfYesDescribeEnabledState(): void {
    const isPhasedYes = this.costReviewSOLConditionFormGroup.controls.projectIsPhased.value === this.constants.YES;
    if (isPhasedYes) {
      this.costReviewSOLConditionFormGroup.controls.ifYesDescribe.enable({ emitEvent: false });
    }
    else {
      this.costReviewSOLConditionFormGroup.controls.ifYesDescribe.disable({ emitEvent: false });
    }
  }

  private subscribeToProjectIsPhasedChanges(): void {
    this.costReviewSOLConditionFormGroup.controls.projectIsPhased.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.syncIfYesDescribeEnabledState());
  }

  private subscribeToDataRefresh(): void {
    this.reviewService.onDataRefreshed$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const isLibraryUsedInSQ = this.reviewDetailTabsService.getIsLibraryUsedInSQ();
        this.isDisabled = isLibraryUsedInSQ ? this.commonDataService.libraryReadOnlyMode : this.isDisabled;
        this.isReadOnlyMode = isLibraryUsedInSQ ? false : this.commonDataService.libraryReadOnlyMode;
        this.updateFormEditability();
      });
  }

initializeConditionFormGroup() {
    this.costReviewSOLConditionFormGroup = this.formBuilder.group({
      minority: this.formBuilder.control(this.constants.EMPTY_STRING),
      prevailingWage: this.formBuilder.control(this.constants.EMPTY_STRING),
      tradeAgreementAct: this.formBuilder.control(this.constants.EMPTY_STRING),
      buyAmerica: this.formBuilder.control(this.constants.EMPTY_STRING),
      buyAmericanAct: this.formBuilder.control(this.constants.EMPTY_STRING),
      bimModeling: this.formBuilder.control(this.constants.EMPTY_STRING),
      schedulerEstimate: this.formBuilder.control(this.constants.EMPTY_STRING),
      cpmHoursEstimated: this.formBuilder.control(this.constants.EMPTY_STRING),
      hardwareSoftwareCapacity: this.formBuilder.control(this.constants.EMPTY_STRING),
      serviceContract: this.formBuilder.control(this.constants.EMPTY_STRING),
      specialProgramming: this.formBuilder.control(this.constants.EMPTY_STRING),
      specialCommissioningProceduresRequired: this.formBuilder.control(this.constants.EMPTY_STRING),
      testProcessReviewed: this.formBuilder.control(this.constants.EMPTY_STRING),
      taggingLabeling: this.formBuilder.control(this.constants.EMPTY_STRING),
      installationStandards: this.formBuilder.control(this.constants.EMPTY_STRING),
      localCodeRestrictions: this.formBuilder.control(this.constants.EMPTY_STRING),
      trailerRentalSpace: this.formBuilder.control(this.constants.EMPTY_STRING),
      utilitiesCosts: this.formBuilder.control(this.constants.EMPTY_STRING),
      projectIsPhased: this.formBuilder.control(this.constants.EMPTY_STRING),
      escortsRequired: this.formBuilder.control(this.constants.EMPTY_STRING),
      customerTaxExempt: this.formBuilder.control(this.constants.EMPTY_STRING),
      officeSuppliesCosts: this.formBuilder.control(this.constants.EMPTY_STRING),
      liftCosts: this.formBuilder.control(this.constants.EMPTY_STRING),
      bim360FieldConfiguration: this.formBuilder.control(this.constants.EMPTY_STRING),
      taxRequired: this.formBuilder.control(this.constants.EMPTY_STRING),
      salesTax: this.formBuilder.control(this.constants.EMPTY_STRING),
      equipmentEnclosures: this.formBuilder.control(this.constants.EMPTY_STRING),
      deviceAccessPanels: this.formBuilder.control(this.constants.EMPTY_STRING),
      fieldProcurementManager: this.formBuilder.control(this.constants.EMPTY_STRING),
      serviceContractGeneralConditions: this.formBuilder.control(this.constants.EMPTY_STRING),
      unionLabor: this.formBuilder.control(this.constants.EMPTY_STRING),
      prevailingWages: this.formBuilder.control(this.constants.EMPTY_STRING),
      certifiedPayrollReports: this.formBuilder.control(this.constants.EMPTY_STRING),
      temporarySitePersonnel: this.formBuilder.control<string[]>([]),
      sparepartpercent : this.formBuilder.control(this.constants.ZERO),
      ifYesDescribe: this.formBuilder.control(this.constants.EMPTY_STRING),
      ifyesdesc: this.formBuilder.control(this.constants.EMPTY_STRING),
      ifYesInstallationStandards: this.formBuilder.control(this.constants.EMPTY_STRING),
      sparepointcapacity: this.formBuilder.control(this.constants.ZERO)
    });
  }


  sendDisablePdfEvent() {
    this.disablePdf.emit(false);
  }

  initializeConditionsData() {
    const costReviewData: CostReviewDatabaseRecord = this.reviewService.costReviewDetails;
    this.checkSellPriceForCPM = !!costReviewData?.reviewObject?.isCpmVisible ;
    this.costReviewGeneralConditions = costReviewData.reviewObject?.costReviewGeneralConditions;
    if (this.business === this.constants.BUSINESS_SECURITY) {
      const securityData = costReviewData.reviewObject as CostReviewSecurityEnUsAttributes;
      this.costReviewSecurityEnUsGeneralConditions = securityData?.costReviewSecurityEnUsGeneralConditions;
    }
    this.mapConditionData();
  }

  mapConditionData() {
    if (this.costReviewGeneralConditions === undefined || this.costReviewGeneralConditions === null) {
      return;
    }
    this.costReviewSOLConditionFormGroup.patchValue({
      minority: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.minority),
      prevailingWage: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.prevailingWage),
      tradeAgreementAct: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.tradeAgreementAct),
      buyAmerica: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.buyAmerica),
      buyAmericanAct: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.buyAmericanAct),
      bimModeling: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.bimModeling),
      schedulerEstimate: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.schedulerEstimate),
      cpmHoursEstimated: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.cpmHoursEstimated),
      hardwareSoftwareCapacity: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.hardwareSoftwareCapacity),
      serviceContract: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.serviceContract),
      specialProgramming: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.specialProgramming),
      specialCommissioningProceduresRequired: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.commissioningProcedures),
      testProcessReviewed: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.testProcessReviewed),
      taggingLabeling: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.taggingLabeling),
      installationStandards: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.installationStandards),
      ifYesInstallationStandards: this.costReviewSecurityEnUsGeneralConditions?.ifYesInstallationStandards ?? this.constants.EMPTY_STRING,
      localCodeRestrictions: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.localCodeRestrictions),
      trailerRentalSpace: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.trailerRentalSpace),
      utilitiesCosts: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.utilitiesCosts),
      projectIsPhased: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.projectIsPhased ?? undefined),
      escortsRequired: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.escortsRequired),
      customerTaxExempt: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.customerTaxExempt),
      officeSuppliesCosts: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.officeSuppliesCosts),
      liftCosts: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.liftCosts),
      bim360FieldConfiguration: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.bim360FieldConfiguration),
      taxRequired: this.getParameterValues(this.constants.SALES_USE_NONE, this.costReviewGeneralConditions.taxRequired),
      salesTax: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.salesTax),
      equipmentEnclosures: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.equipmentEnclosures),
      deviceAccessPanels: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.deviceAccessPanels),
      fieldProcurementManager: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.fieldProcurementManager),
      serviceContractGeneralConditions: this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.serviceContract),
      unionLabor: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.unionLabor),
      prevailingWages: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.prevailingWages),
      certifiedPayrollReports: this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.certifiedPayrollReports),
      temporarySitePersonnel: this.mapTemporarySitePersonnelIds(this.costReviewGeneralConditions.temporarySitePersonnel),
      sparepartpercent: (this.costReviewGeneralConditions.sparePartsPercent ?? this.constants.ZERO),
      ifYesDescribe: this.costReviewGeneralConditions?.ifYesDescribe ?? this.constants.EMPTY_STRING,
      ifyesdesc: this.costReviewSecurityEnUsGeneralConditions?.ifYesDescribe ?? this.constants.EMPTY_STRING,
      sparepointcapacity: (this.costReviewGeneralConditions.sparePointCapacity ?? this.constants.ZERO)
    });
  }

  ngOnDestroy() {
    this.pushFormDataToService();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private pushFormDataToService(): void {
    if (!this.costReviewSOLConditionFormGroup || !this.costReviewGeneralConditions) return;
    const formData = this.costReviewSOLConditionFormGroup.getRawValue();

    // General conditions (all YES_NO)
    this.costReviewGeneralConditions.minority = this.getParameterCode(formData.minority, this.costReviewGeneralConditions.minority);
    this.costReviewGeneralConditions.prevailingWage = this.getParameterCode(formData.prevailingWage, this.costReviewGeneralConditions.prevailingWage);
    this.costReviewGeneralConditions.tradeAgreementAct = this.getParameterCode(formData.tradeAgreementAct, this.costReviewGeneralConditions.tradeAgreementAct);
    this.costReviewGeneralConditions.buyAmerica = this.getParameterCode(formData.buyAmerica, this.costReviewGeneralConditions.buyAmerica);
    this.costReviewGeneralConditions.buyAmericanAct = this.getParameterCode(formData.buyAmericanAct, this.costReviewGeneralConditions.buyAmericanAct);
    this.costReviewGeneralConditions.bimModeling = this.getParameterCode(formData.bimModeling, this.costReviewGeneralConditions.bimModeling);
    this.costReviewGeneralConditions.schedulerEstimate = this.getParameterCode(formData.schedulerEstimate, this.costReviewGeneralConditions.schedulerEstimate);
    this.costReviewGeneralConditions.cpmHoursEstimated = this.getParameterCode(formData.cpmHoursEstimated, this.costReviewGeneralConditions.cpmHoursEstimated);
    this.costReviewGeneralConditions.trailerRentalSpace = this.getParameterCode(formData.trailerRentalSpace, this.costReviewGeneralConditions.trailerRentalSpace);
    this.costReviewGeneralConditions.utilitiesCosts = this.getParameterCode(formData.utilitiesCosts, this.costReviewGeneralConditions.utilitiesCosts);
    this.costReviewGeneralConditions.projectIsPhased = this.getParameterCode(formData.projectIsPhased, this.costReviewGeneralConditions.projectIsPhased ?? 0);
    this.costReviewGeneralConditions.officeSuppliesCosts = this.getParameterCode(formData.officeSuppliesCosts, this.costReviewGeneralConditions.officeSuppliesCosts);
    this.costReviewGeneralConditions.liftCosts = this.getParameterCode(formData.liftCosts, this.costReviewGeneralConditions.liftCosts);
    this.costReviewGeneralConditions.bim360FieldConfiguration = this.getParameterCode(formData.bim360FieldConfiguration, this.costReviewGeneralConditions.bim360FieldConfiguration);
    this.costReviewGeneralConditions.taxRequired = this.getParameterCode(formData.taxRequired, this.costReviewGeneralConditions.taxRequired);
    this.costReviewGeneralConditions.salesTax = this.getParameterCode(formData.salesTax, this.costReviewGeneralConditions.salesTax);
    this.costReviewGeneralConditions.equipmentEnclosures = this.getParameterCode(formData.equipmentEnclosures, this.costReviewGeneralConditions.equipmentEnclosures);
    this.costReviewGeneralConditions.deviceAccessPanels = this.getParameterCode(formData.deviceAccessPanels, this.costReviewGeneralConditions.deviceAccessPanels);
    this.costReviewGeneralConditions.fieldProcurementManager = this.getParameterCode(formData.fieldProcurementManager, this.costReviewGeneralConditions.fieldProcurementManager);
    this.costReviewGeneralConditions.serviceContract = this.getParameterCode(formData.serviceContractGeneralConditions, this.costReviewGeneralConditions.serviceContract);

    // Direct array field
    this.costReviewGeneralConditions.temporarySitePersonnel = (formData.temporarySitePersonnel ?? [])
    .map(key => this.reviewService.getCostReviewParametersCode(this.constants.TEMPORARY_SITE_PERSONNEL, this.translate.instant(key)))
    .filter((code): code is number => !!code);
    this.costReviewGeneralConditions.sparePartsPercent = formData.sparepartpercent ?? 0;
    this.costReviewGeneralConditions.ifYesDescribe = formData.ifYesDescribe ?? this.costReviewGeneralConditions.ifYesDescribe;
    this.costReviewGeneralConditions.sparePointCapacity = formData.sparepointcapacity ?? 0;

    // Security general conditions (YES_NO)
    if (this.costReviewSecurityEnUsGeneralConditions) {
      this.costReviewSecurityEnUsGeneralConditions.hardwareSoftwareCapacity = this.getParameterCode(formData.hardwareSoftwareCapacity, this.costReviewSecurityEnUsGeneralConditions.hardwareSoftwareCapacity);
      this.costReviewSecurityEnUsGeneralConditions.serviceContract = this.getParameterCode(formData.serviceContract, this.costReviewSecurityEnUsGeneralConditions.serviceContract);
      this.costReviewSecurityEnUsGeneralConditions.specialProgramming = this.getParameterCode(formData.specialProgramming, this.costReviewSecurityEnUsGeneralConditions.specialProgramming);
      this.costReviewSecurityEnUsGeneralConditions.commissioningProcedures = this.getParameterCode(formData.specialCommissioningProceduresRequired, this.costReviewSecurityEnUsGeneralConditions.commissioningProcedures);
      this.costReviewSecurityEnUsGeneralConditions.testProcessReviewed = this.getParameterCode(formData.testProcessReviewed, this.costReviewSecurityEnUsGeneralConditions.testProcessReviewed);
      this.costReviewSecurityEnUsGeneralConditions.taggingLabeling = this.getParameterCode(formData.taggingLabeling, this.costReviewSecurityEnUsGeneralConditions.taggingLabeling);
      this.costReviewSecurityEnUsGeneralConditions.installationStandards = this.getParameterCode(formData.installationStandards, this.costReviewSecurityEnUsGeneralConditions.installationStandards);
      this.costReviewSecurityEnUsGeneralConditions.localCodeRestrictions = this.getParameterCode(formData.localCodeRestrictions, this.costReviewSecurityEnUsGeneralConditions.localCodeRestrictions);
      this.costReviewSecurityEnUsGeneralConditions.escortsRequired = this.getParameterCode(formData.escortsRequired, this.costReviewSecurityEnUsGeneralConditions.escortsRequired);
      this.costReviewSecurityEnUsGeneralConditions.customerTaxExempt = this.getParameterCode(formData.customerTaxExempt, this.costReviewSecurityEnUsGeneralConditions.customerTaxExempt);
      this.costReviewSecurityEnUsGeneralConditions.unionLabor = this.getParameterCode(formData.unionLabor, this.costReviewSecurityEnUsGeneralConditions.unionLabor);
      this.costReviewSecurityEnUsGeneralConditions.prevailingWages = this.getParameterCode(formData.prevailingWages, this.costReviewSecurityEnUsGeneralConditions.prevailingWages);
      this.costReviewSecurityEnUsGeneralConditions.certifiedPayrollReports = this.getParameterCode(formData.certifiedPayrollReports, this.costReviewSecurityEnUsGeneralConditions.certifiedPayrollReports);
      this.costReviewSecurityEnUsGeneralConditions.ifYesInstallationStandards = formData.ifYesInstallationStandards ?? this.costReviewSecurityEnUsGeneralConditions.ifYesInstallationStandards;
    }
  }

  getParameterValues(key: string, value: string | number | undefined): string {
    return this.reviewService.getCostReviewParametersDescription(key, value)
  }

  getParameterValuesForArray(key: string, value: Array<string | number>): string {
    return this.reviewService.getCostReviewParametersDescriptionForArray(key, value)
  }

  private getParameterCode(description: string, currentValue: number): number {
    const code = this.reviewService.getCostReviewParametersCode(this.constants.YES_NO, description);
    return code !== undefined ? code : currentValue;
  }

  showConditionData(): boolean {
    if (this.business === this.constants.BUSINESS_SECURITY) {
      return true;
    }
    if (!this.costReviewGeneralConditions) {
      return false;
    }
    if (this.business === this.constants.BUSINESS_FIRE) {
      return true;
    }
    if ((this.business === this.constants.BUSINESS_AUTOMATION
        || this.business === this.constants.BUSINESS_ELECTRICAL
        || this.business === this.constants.BUSINESS_MECHANICAL) && this.isSalePriceGreaterThan150) {
      return true;
    }
    return false;
  }

  showFieldAlways(): boolean {
    return this.business === this.constants.BUSINESS_AUTOMATION
        || this.business === this.constants.BUSINESS_ELECTRICAL
        || this.business === this.constants.BUSINESS_MECHANICAL
        || this.business === this.constants.BUSINESS_FIRE;
  }

  showFieldForFireOnly(): boolean {
    return this.business === this.constants.BUSINESS_FIRE;
  }

  showFieldOnlyIfApplicable(): boolean {
    return (this.business === this.constants.BUSINESS_AUTOMATION || this.business === this.constants.BUSINESS_ELECTRICAL
           || this.business === this.constants.BUSINESS_MECHANICAL || this.business === this.constants.BUSINESS_FIRE)
           && this.isSalePriceGreaterThan150;
  }

  showFieldsForFireORAutomationElectrical(): boolean {
    return (this.business === this.constants.BUSINESS_FIRE) || ((this.business === this.constants.BUSINESS_AUTOMATION
            || this.business === this.constants.BUSINESS_ELECTRICAL || this.business === this.constants.BUSINESS_MECHANICAL)
            && this.isSalePriceGreaterThan150);
  }

  showSalesTaxField(): boolean {
    return (this.business === this.constants.BUSINESS_AUTOMATION
        || this.business === this.constants.BUSINESS_ELECTRICAL
        || this.business === this.constants.BUSINESS_MECHANICAL)
        && this.isSalePriceGreaterThan150
        && !!this.costReviewGeneralConditions?.salesTax;
  }

  showEquipmentField(): boolean {
    return this.business === this.constants.BUSINESS_AUTOMATION
        || this.business === this.constants.BUSINESS_ELECTRICAL
        || this.business === this.constants.BUSINESS_MECHANICAL;
  }

  private exportConditionsPdf(
    data: any,
    title: string,
    selectedReview: ReviewDetails
  ) {
    const options: ExportObjectAsFieldValuePDFOptions = {
      data,
      title,
      fileName: 'conditions.pdf',
      estimateID: selectedReview.estimateID,
      estimateName: selectedReview.request,
      tabName: this.translate.instant('REVIEW_SOL_TABS_LABELS.CONDITIONS'),
    };
    this.commonFunctionsService.exportObjectAsFieldValuePDF(options);
  }

  exportToPdf(selectedReview: ReviewDetails, tabName: string) {
    if (tabName === this.constants.SOL_CONDITIONS) {
      if (!this.showConditionData()) {
        this.exportConditionsPdf(
          { [this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.CONDITIONS_DATA_NOT_FOUND')]: Constants.EMPTY_STRING },
          Constants.EMPTY_STRING,
          selectedReview
        );
        return;
      }

      const docData: ExportTitleCaseMap = {};

      this.addFireOrAutomationElectricalFields(docData);
      this.addFieldOnlyIfApplicableFields(docData);
      this.addUtilitiesCostsField(docData);
      this.addProjectPhasedFields(docData);
      this.addFireBusinessFields(docData);
      this.addEquipmentField(docData);
      this.addSparePointCapacityField(docData);
      this.addTaxFields(docData);
      this.addSalesTaxField(docData);
      this.addCPMField(docData);
      this.addSecuritySpecificFields(docData);
      this.addSectionNotApplicableFields(docData);

      const orderedFields = [
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.MINORITY_REQUIREMENTS'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PREVAILING_WAGE_REQUIREMENTS'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TRADE_AGREEMENT_ACT_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BUY_AMERICA_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BUY_AMERICAN_ACT_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BIM_MODELLING_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SCHEDULER_ESTIMATE_RECEIVED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.CPM_HOURS_ESTIMATED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TRAVEL_EXPENSES_PLANNED'),
        'Travel expenses planned (Security)',
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.OVERTIME_PWR_ESTIMATED'),
        'Overtime/PWR estimated (Security)',
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.ESCALATION_INCLUDED'),
        'Escalation included (Security)',
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TRAILER_RENTAL_SPACE_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.UTILITIES_COSTS_ESTIMATED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PROJECT_IS_PHASED'),
        'If Yes, describe',
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.OFFICE_SUPPLIES_COSTS_ESTIMATED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.LIFT_COSTS_ESTIMATED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BIM_360_FIELD_CONFIGURATION_ESTIMATED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SALES_TAX_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPARE_PARTS_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.EQUIPMENT_ENCLOSURES_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.DEVICE_ACCESS_PANELS_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.FIELD_PROCUREMENT_MANAGER_ASSIGNED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TEMPORARY_SITE_PERSONNEL'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SERVICE_CONTRACT_REQUIRED_AS_PART_OF_THE_BID'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PARKING_FEES'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPARE_POINT_CAPACITY'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TAX_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPECIAL_PROGRAMMING_REQUIRED'),
        'If yes, describe (special programming)',
        this.translate.instant('REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.SPECIAL_COMMISSIONING_PROCEDURES_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.IF_YES_TEST_PROCESS_REVIEWED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPECIAL_TAGGING_LABELING_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPECIAL_INSTALLATION_STANDARDS_REQUIRED'),
        'If yes, describe (installation standards)',
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.LOCAL_CODE_RESTRICTIONS_FOR_INSTALLED_DOOR_HARDWARE'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.ESCORTS_REQUIRED_IN_WORK_AREAS'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.CUSTOMER_TAX_EXEMPT'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.UNION_LABOR_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PREVAILING_WAGES_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.IF_YES_CERTIFIED_PAYROLL_REPORTS_REQUIRED'),
        this.translate.instant('REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE'),
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.CONDITIONS_DATA_NOT_FOUND')
      ];

      // Build a new object with fields in the desired order
      const orderedDocData: ExportTitleCaseMap = {};
      orderedFields.forEach(field => {
        if (docData[field] !== undefined) {
          orderedDocData[field] = docData[field];
        }
      });
      // Optionally, add any remaining fields not in the list
      Object.keys(docData).forEach(key => {
        if (!(key in orderedDocData)) {
          orderedDocData[key] = docData[key];
        }
      });

      this.exportConditionsPdf(
        orderedDocData,
        this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TITLE'),
        selectedReview
      );
    }
  }

  addFireOrAutomationElectricalFields(docData: ExportTitleCaseMap) {
    if (this.showFieldsForFireORAutomationElectrical()) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.MINORITY_REQUIREMENTS')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.minority);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PREVAILING_WAGE_REQUIREMENTS')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.prevailingWage);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BUY_AMERICA_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.buyAmerica);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BUY_AMERICAN_ACT_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.buyAmericanAct);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.OVERTIME_PWR_ESTIMATED')] =
      this.costReviewGeneralConditions?.overtimeEstimated ?? Constants.EMPTY_STRING;
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.ESCALATION_INCLUDED')] =
      this.costReviewGeneralConditions?.escalationIncluded ?? Constants.EMPTY_STRING;
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.LIFT_COSTS_ESTIMATED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.liftCosts);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPARE_PARTS_REQUIRED')] =
      (this.costReviewGeneralConditions?.sparePartsPercent != null) ?
      `${this.decimalPrecisionPipe.transform(this.costReviewGeneralConditions.sparePartsPercent)}%` : Constants.EMPTY_STRING;
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.DEVICE_ACCESS_PANELS_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.deviceAccessPanels);
    }
  }

  addFieldOnlyIfApplicableFields(docData: ExportTitleCaseMap) {
    if (this.showFieldOnlyIfApplicable()) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TRADE_AGREEMENT_ACT_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.tradeAgreementAct);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BIM_MODELLING_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.bimModeling);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SCHEDULER_ESTIMATE_RECEIVED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.schedulerEstimate);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TRAVEL_EXPENSES_PLANNED')] =
      this.costReviewGeneralConditions?.travelExpensesPlanned != null
        ? `$${this.costReviewGeneralConditions.travelExpensesPlanned}` : Constants.EMPTY_STRING;
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TRAILER_RENTAL_SPACE_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.trailerRentalSpace);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.OFFICE_SUPPLIES_COSTS_ESTIMATED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.officeSuppliesCosts);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.BIM_360_FIELD_CONFIGURATION_ESTIMATED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.bim360FieldConfiguration);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.FIELD_PROCUREMENT_MANAGER_ASSIGNED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.fieldProcurementManager);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TEMPORARY_SITE_PERSONNEL')] =
      this.getParameterValuesForArray(this.constants.TEMPORARY_SITE_PERSONNEL, this.costReviewGeneralConditions?.temporarySitePersonnel ?? []);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SERVICE_CONTRACT_REQUIRED_AS_PART_OF_THE_BID')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.serviceContract);
    }
  }

  addUtilitiesCostsField(docData: ExportTitleCaseMap) {
    if ((this.business === this.constants.BUSINESS_AUTOMATION || this.business === this.constants.BUSINESS_ELECTRICAL
      || this.business === this.constants.BUSINESS_MECHANICAL) && this.isSalePriceGreaterThan150) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.UTILITIES_COSTS_ESTIMATED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.utilitiesCosts);
    }
  }

  addProjectPhasedFields(docData: ExportTitleCaseMap) {
    if (this.costReviewGeneralConditions && this.costReviewGeneralConditions.projectIsPhased != null) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PROJECT_IS_PHASED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions.projectIsPhased);
      if (this.costReviewGeneralConditions.projectIsPhased === this.constants.ONE) {
        docData['If Yes, describe'] = this.costReviewGeneralConditions.ifYesDescribe ?? Constants.EMPTY_STRING;
      }
    }
  }

  addFireBusinessFields(docData: ExportTitleCaseMap) {
    if (this.business === this.constants.BUSINESS_FIRE && this.isSalePriceGreaterThan150) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PARKING_FEES')] =
      this.costReviewGeneralConditions?.parkingFees != null
        ? `$${this.costReviewGeneralConditions.parkingFees}` : Constants.EMPTY_STRING;
    }
  }

  addEquipmentField(docData: ExportTitleCaseMap) {
    if (this.showEquipmentField()) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.EQUIPMENT_ENCLOSURES_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.equipmentEnclosures);
    }
  }

  addSparePointCapacityField(docData: ExportTitleCaseMap) {
    if (this.business === this.constants.BUSINESS_FIRE) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPARE_POINT_CAPACITY')] =
      (this.costReviewGeneralConditions?.sparePointCapacity != null)
        ? `${this.decimalPrecisionPipe.transform(this.costReviewGeneralConditions.sparePointCapacity)}%` : Constants.EMPTY_STRING;
    }
  }

  addTaxFields(docData: ExportTitleCaseMap) {
    if (this.business !== this.constants.BUSINESS_AUTOMATION && this.business !==
      this.constants.BUSINESS_MECHANICAL && this.business === this.constants.BUSINESS_FIRE) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.TAX_REQUIRED')] =
      this.getParameterValues(this.constants.SALES_USE_NONE, this.costReviewGeneralConditions?.taxRequired);
    }
  }

  addSalesTaxField(docData: ExportTitleCaseMap) {
    if (this.showSalesTaxField()) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SALES_TAX_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.salesTax);
    }
  }

  addCPMField(docData: ExportTitleCaseMap) {
    if (this.checkSellPriceForCPM) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.CPM_HOURS_ESTIMATED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewGeneralConditions?.cpmHoursEstimated);
    }
  }

  addSecuritySpecificFields(docData: ExportTitleCaseMap) {
    if (this.business === this.constants.BUSINESS_SECURITY) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPARE_HARDWARE_SOFTWARE_CAPACITY_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.hardwareSoftwareCapacity);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SERVICE_CONTRACT_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.serviceContract);

      if (this.isSalePriceGreaterThan150) {
        docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPECIAL_PROGRAMMING_REQUIRED')] =
        this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.specialProgramming);
      }

      if ((this.costReviewSecurityEnUsGeneralConditions?.specialProgramming === this.constants.ONE) || this.isSalePriceGreaterThan150) {
        docData['If yes, describe (special programming)'] = this.costReviewSecurityEnUsGeneralConditions?.ifYesDescribe ?? Constants.EMPTY_STRING;
      }

      // docData[this.translate.instant('REVIEW_SOL_CHECKLIST_TAB.EXECUTION_SCHEDULE.SPECIAL_COMMISSIONING_PROCEDURES_REQUIRED')] =
      // this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.specialCommissioningProceduresRequired);

      if (this.costReviewSecurityEnUsGeneralConditions?.commissioningProcedures === this.constants.ONE) {
        docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.IF_YES_TEST_PROCESS_REVIEWED')] =
        this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.testProcessReviewed);
      }

      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPECIAL_TAGGING_LABELING_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.taggingLabeling);

      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.SPECIAL_INSTALLATION_STANDARDS_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.installationStandards);

      if (this.costReviewSecurityEnUsGeneralConditions?.installationStandards === this.constants.ONE)
        {
        docData['If yes, describe (installation standards)'] =
        this.costReviewSecurityEnUsGeneralConditions?.ifYesInstallationStandards ?? Constants.EMPTY_STRING;
      }
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.LOCAL_CODE_RESTRICTIONS_FOR_INSTALLED_DOOR_HARDWARE')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.localCodeRestrictions);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.ESCORTS_REQUIRED_IN_WORK_AREAS')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.escortsRequired);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.CUSTOMER_TAX_EXEMPT')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.customerTaxExempt);
      docData['Overtime/PWR estimated (Security)'] =
      this.costReviewSecurityEnUsGeneralConditions?.overtimeEstimated ?? Constants.EMPTY_STRING;
      docData['Escalation included (Security)'] =
      this.costReviewSecurityEnUsGeneralConditions?.escalationIncluded ?? Constants.EMPTY_STRING;
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.UNION_LABOR_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.unionLabor);
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.PREVAILING_WAGES_REQUIRED')] =
      this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.prevailingWages);
      if (this.costReviewSecurityEnUsGeneralConditions?.prevailingWages === this.constants.ONE) {
        docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.IF_YES_CERTIFIED_PAYROLL_REPORTS_REQUIRED')] =
        this.getParameterValues(this.constants.YES_NO, this.costReviewSecurityEnUsGeneralConditions?.certifiedPayrollReports);
      }
      if (this.isSalePriceGreaterThan150) {
        docData['Travel expenses planned (Security)'] = this.costReviewGeneralConditions?.travelExpensesPlanned != null
          ? `$${this.costReviewGeneralConditions.travelExpensesPlanned}` : Constants.EMPTY_STRING;
      }
    }
  }

  addSectionNotApplicableFields(docData: ExportTitleCaseMap) {
    if (!this.showConditionData() && this.business === this.constants.BUSINESS_FIRE && !this.showSectionNotApplicableMsg) {
      docData[this.translate.instant('REVIEW_SOL_CHECKLIST_TAB.SECTION_NOT_APPLICABLE')] = Constants.EMPTY_STRING;
    }
    if (this.showSectionNotApplicableMsg && !this.showConditionData()) {
      docData[this.translate.instant('REVIEW_SOL_CONDITIONS_TAB.CONDITIONS_DATA_NOT_FOUND')] = Constants.EMPTY_STRING;
    }
  }

  get isFeildEnabled(): (fieldName: string) => boolean {
    return (fieldName: string) => this.commonFunctionsService.isControlValueEqualToTranslation(this.costReviewSOLConditionFormGroup, fieldName, 'YES');
  }
  private mapTemporarySitePersonnelIds(ids:number[] | undefined): string[] {
    if(!ids?.length) return [];
    return ids
    .map(id => {
      const desc = this.reviewService.getCostReviewParametersDescription(this.constants.TEMPORARY_SITE_PERSONNEL, id);
      return this.temporarySitePersonnelList.find(key => this.translate.instant(key) === desc);

    }).filter((key) : key is string => !!key);
  }

    formControlsValueForString(formGroup: FormGroup | undefined, formControlName: string): string {
    return this.commonFunctionsService.formControlsValueForString(formGroup, formControlName);
  }
}
